export default "__VITE_ASSET__BbcyPoEE__"